<template>
    <div
      class=" w-100 d-flex  flex-column justify-content-start align-items-center overflow-auto background-texture "
    >
     <div class="logo-elite">
      <img
          src="../../../assets/EliteFitAI-Logo.svg"
          alt="active-health"
           @click="logout()"
        />
        <span
          class=""
          >EliteFit.AI</span>
      </div>
    <div class="fit-summit">
      <label class="font-30 my-4">Leaderboard</label>
    </div>
     
      <div class="w-50 mx-w-xl mb-2 z-index-10">
        <b-table
          :items="getLeaderBoard"
          :fields="fields"
          :tbody-tr-class="rowClass"
          responsive="sm"
        >
          <template #cell(rank)="data">
            <div
              class="rank-bg d-flex justify-content-center align-items-center font-weight-bold"
            >
              <span
                class="rank-bg d-flex justify-content-center align-items-center"
                :class="getRankColor(data.item.rank)"
                >{{ data.item.rank }}</span
              >
            </div>
          </template>
          <template #cell(name)="data">
            <div
              class="p-2 rounded d-flex justify-content-center align-items-center font-weight-bold text-center"
              :title="data.item.name"
              v-b-tooltip.hover
            >
              {{ data.item.name.substring(0, 10) + (data.item.name.length > 10 ? '..' : '')}}
              <span class="text-invisible">{{ data.item.mobile}}</span>
            </div>
          </template>
          <template #cell(company)="data">
            <div
              class="p-2 rounded d-flex justify-content-center align-items-center font-weight-bold"
            >
              {{ data.item.company }}
            </div>
          </template>
          <template #cell(accuracy)="data">
            <div
              class="p-2 rounded d-flex justify-content-center align-items-center font-weight-bold"
            >
              {{ data.item.accuracy }}%
            </div>
          </template>
        </b-table>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <div
          class="w-auto py-2 cursor-pointer px-5 bg-green d-flex text-white justify-content-center align-items-center btn-common font-26"
          @click="redirectToInfo()"
        >
          Back to Start
        </div>
      </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters, mapActions } = createNamespacedHelpers("fitClient");
export default {
  data() {
    return {
      leaderboardInterval: null,
      fields: [
        {
          key: "rank",
          label: "RANK",
          thClass: "bg-brown text-white text-center align-middle headClass",
          tdClass: "align-middle"
        },
        {
          key: "name",
          label: "NAME",
          thClass: "bg-brown text-white text-center align-middle headClass",
          tdClass: "align-middle"
        },
        {
          key: "company",
          label: "COMPANY",
          thClass: "bg-brown text-white text-center align-middle headClass",
          tdClass: "align-middle"
        },
        {
          key: "accuracy",
          label: "ACCURACY",
          thClass: "bg-brown text-white text-center align-middle headClass",
          tdClass: "align-middle"
        },
      ],
      isMouseEnter: false,
    };
  },

  methods: {
    ...mapActions(["uploadDetailsAndGetLeaderBoard"]),
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.email === this.getEmail) return "table-success";
      else return "table-light";
    },
    logout() {
      const result = confirm("If you want to logout?")
      if(result){
        localStorage.removeItem("login");
        this.$router.push({ name: "fit-summit-sign-in" });
      }
    },
    getRankColor(rank) {
      switch (rank) {
        case 1:
          return "bg-yellow";
        case 2:
          return "bg-gray";
        case 3:
          return "bg-brown";
        default:
          return "bg-black";
      }
    },
    redirectToInfo() {
      this.$router.push({ name: "fit-summit-intro-page" });
    },
    refresh() {
      /**
       * Refresh the leaderboard after every 30 seconds.
       */
      this.leaderboardInterval = setInterval(async () => {
        await this.uploadDetailsAndGetLeaderBoard({
          leaderBoard: true
        });
      },30000);
    },
    async uploadMethod(){
      await this.uploadDetailsAndGetLeaderBoard({
        leaderBoard: true
      });
    }
  },
  computed: {
    ...mapGetters(["getLeaderBoard"]),
    getEmail(){
      return localStorage.getItem('user-email') ? localStorage.getItem('user-email') : null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      /**
       * Fetch the leaderboard data on page load when coming directly to this page.
       * When coming from normal user details page, we already have the data and we don't need to send another request. 
       */
      if(from  && from.path && from.path != "/fitsummit/user-details"){
        vm.uploadMethod();
      }
    })
  },
  mounted() {
    this.refresh();
  },
  destroyed(){
    clearInterval(this.leaderboardInterval);
  }
};
</script>

<style>
.bg-full {
  background-image: url("../assets/images/bg-fitsummit.png");
}
.ef-logo-text{
  padding: 25px;
}
.rank-bg {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: white;
  margin-left: auto;
  margin-right: auto;
}
.rank-border-first {
  outline: 3px solid #ff9900;
}
.rank-border-second {
  outline: 3px solid #e46327;
}
.rank-border-third {
  outline: 3px solid #424242;
}
.rank-border-fourth {
  outline: 3px solid #767a75;
}
.table thead th {
  border: 0;
}

.table tbody tr {
  border-top: 2px solid #767a75;
}
.table tbody tr:last-child {
  border-bottom: 2px solid #767a75;
}
.table tbody tr:first-child {
  border-top: 0;
}

/* new */

.background-texture {
    background-image: url("../assets/images/bg-fitsummit.png");
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    min-height: 100vh;
    position: relative;
}

.fit-summit {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 15px;
}

.fit-summit label{
    margin: 0 !important;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    color: #000;
}

tr.table-light td:nth-child(1) {
    border: 0;
    border-radius: 15px 0 0 15px ;
    overflow: hidden;
    background-color: #fafafa;
}

tr.table-light td:nth-last-child(1) {
    border: 0;
    border-radius: 0 15px 15px 0;
    overflow: hidden;
    background-color: #fafafa;
}
.table tbody tr {
  border-top: 7px solid transparent !important;
}

tr.table-light td {
    border: 0;
    border-radius: 0px;
    padding: 7px 15px;
    overflow: hidden;
    background-color: #fafafa;
}

tr.table-light:nth-child(odd) td {
  background-color: #fafafa;
}

.table thead th {
  padding: 18px 15px 10px 15px;
  background-color: #326E1D !important;

}
.table thead th:nth-last-child(1){
   border-radius: 0 15px 15px 0;
}

.table thead tr {
  border-bottom: 0px solid transparent !important;
}

.table-success td {
    border-top: 7px solid transparent !important;
     padding: 7px 15px !important;
}

 .table-success td:nth-last-child(1) {
      border-radius: 0 15px 15px 0;
 }
.table-success td:nth-child(1) {
      border-radius:  15px 0 0 15px;
 }

.table thead th:nth-child(1){
    border-radius: 15px 0 0 15px;
}

.table tbody tr:last-child {
     border-bottom: 0px !important; 
}

 .btn-common {
    border-radius: 8px;
    font-size: 18px;
    font-weight: 600;
    height: 50px;
    background-color: #326E1D;
    min-width: 230px;
    color: #fff;
}

tr.table-light td, .table thead th {font-size: 16px;}

.logo-elite {
  display: flex;
  align-items: center;
  justify-content: baseline;
  position: absolute;
  left: 40px;
  top: 40px;
}

.logo-elite img {
  width: 70px;
  height: auto;
  object-fit: contain;
}

.logo-elite span {
  font-weight: 500;
  color: #000;
  font-size: 16px;
}


@media (max-width: 1600px) { 

.table thead th {
    padding: 12px 15px 8px 15px;
    background-color: #326e1d !important
}

.table-success td {
    border-top: 3px solid transparent !important;
    padding: 3px 15px !important
}

tr.table-light td {
    padding: 3px 15px !important;
    border-top: 3px solid transparent !important;
    font-size: 14px !important;

}

.rank-bg {
  height: 25px;
  width: 25px;
}

}

tr td:nth-child(2) .text-invisible {
  opacity: 0;
  display: block;
  position: absolute;
  }
</style>
